// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";

import Backdrop from "@mui/material/Backdrop";
import image_url from "../assets/images/image_url";

const BackdropComponent = () => {
  const backdropRef = useRef(null);
  const [dimension, setDimension] = useState(backdropRef.current);

  useEffect(() => {
    const height = backdropRef.current?.getBoundingClientRect()?.height;
    const width = backdropRef.current?.getBoundingClientRect()?.width;
    const dimension = Math.min(height / 2, width / 2);
    setDimension(dimension);
  }, [backdropRef]);

  return (
    <Backdrop
      ref={backdropRef}
      style={{
        opacity: 0.5,
        visibility: "visible",
      }}
      sx={{
        color: "#fff",
        position: "fixed",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <img
        src={image_url.LOADER_MCHI_GIF}
        width={dimension}
        height={dimension}
      />
    </Backdrop>
  );
};

export default BackdropComponent;
